<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8.45312 0.667969H2.21641C1.82749 0.667969 1.4545 0.822465 1.1795 1.09747C0.904496 1.37247 0.75 1.74546 0.75 2.13437V13.8656C0.75 14.2545 0.904496 14.6275 1.1795 14.9025C1.4545 15.1775 1.82749 15.332 2.21641 15.332H12.0148C12.4038 15.332 12.7767 15.1775 13.0517 14.9025C13.3268 14.6275 13.4812 14.2545 13.4812 13.8656V8.2668" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
    <path d="M3.68359 0.667969V15.332M5.8832 3.33398H9.45312M5.88281 6.2668H7.45312" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
    <path d="M7.49609 8.99902L8.19609 6.19902L12.3961 1.99902L14.4961 4.09902L10.2961 8.29902L7.49609 8.99902Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconObservation'
}
</script>
